import R from 'ramda'

const GOOGLE_SHEET_URL_PATTERN_STRING =
  '^(https://docs.google.com/spreadsheets/d/)(?<spreadsheetId>[a-zA-Z0-9-_]+)(/edit)?(#gid=(?<sheetId>\\d+))?$'
export const GOOGLE_SHEET_URL_PATTERN = new RegExp(
  GOOGLE_SHEET_URL_PATTERN_STRING
)

const matchSheetRegex = sheetUrl => GOOGLE_SHEET_URL_PATTERN.exec(sheetUrl)

const parseGoogleSpreadsheetId = R.pipe(
  R.prop('sheetUrl'),
  matchSheetRegex,
  R.path(['groups', 'spreadsheetId'])
)

const parseGoogleSheetId = R.pipe(
  R.prop('sheetUrl'),
  matchSheetRegex,
  R.pathOr(0, ['groups', 'sheetId']),
  Number
)

const GOOGLE_SHEET_APPEND_ACTION_TYPE = 'GOOGLE_SHEET_APPEND'
const GOOGLE_SHEET_APPEND_DISPLAY_TYPE = 'Google Sheet Append'

const isGoogleSheetAppendFormAction = R.propEq(
  'type',
  GOOGLE_SHEET_APPEND_DISPLAY_TYPE
)

const convertGoogleSheetAppendFormActionToWidgetAction = R.applySpec({
  type: R.always(GOOGLE_SHEET_APPEND_ACTION_TYPE),
  spreadsheetId: parseGoogleSpreadsheetId,
  sheetId: parseGoogleSheetId,
  row: R.prop('row')
})

export {
  isGoogleSheetAppendFormAction,
  convertGoogleSheetAppendFormActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/common/form-to-widget/google-sheet-append.js